import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { catchError, finalize, map } from 'rxjs/operators';
import { SaleFullViewingLogStatistcs, SaleViewingLogSummary, StatsFilters } from 'src/app/models/statistics/statistics.model';
import { environment } from 'src/environments/environment';
import { LookupModel } from '../../models/common/lookup.model';
import { SpinnerService } from './spinner.service';

@Injectable({
  providedIn: 'root',
})
export class StatisticsService {
  public baseUrl = environment.api2BaseUrl;
  public onError: BehaviorSubject<string> = new BehaviorSubject('');
  public serviceParameter = {
    'Content-Type': 'application/json; charset=utf-8',
    Accept: 'application/json',
    Authorization: '',
  };

  public constructor(private readonly http: HttpClient, private readonly spinnerService: SpinnerService) { } // Inject SpinnerService

  public getFullViewingLog(saleUID: string, uid?: string, saleMemberId?: number, type?: string, filter?: StatsFilters): Observable<SaleFullViewingLogStatistcs[]> {
    let requestUrl = `${this.baseUrl}/api/Sales/stats/details`;
    if (uid !== null) {
      requestUrl = `${requestUrl}?saleUID=${saleUID}&uid=${uid}&saleMemberId=${saleMemberId}&type=${type}`;
    } else {
      requestUrl = `${requestUrl}?saleUID=${saleUID}`;
    }

    this.spinnerService.addRequest('getFullViewingLog'); // Show spinner
    return this.http
      .post<SaleFullViewingLogStatistcs[]>(requestUrl, filter ?? {}, {
        withCredentials: false,
        observe: 'response',
      })
      .pipe(
        map((res: any) => {
          if (res.error) {
            throw new Error(res.error);
          }
          return res.body;
        }),
        catchError((error: Error) => {
          this.onError.next(error.message);
          return throwError(error);
        }),
        finalize(() => this.spinnerService.popRequest('getFullViewingLog')) // Hide spinner on completion
      );
  }

  public getSaleViewingSummary(saleUID: string, uid?: string, saleMemberId?: number, type?: string, filter?: StatsFilters): Observable<SaleViewingLogSummary[]> {
    let requestUrl = `${this.baseUrl}/api/Sales/stats/summary`;
    if (uid !== null) {
      requestUrl = `${requestUrl}?saleUID=${saleUID}&uid=${uid}&saleMemberId=${saleMemberId}&type=${type}`;
    } else {
      requestUrl = `${requestUrl}?saleUID=${saleUID}`;
    }

    this.spinnerService.addRequest('getSaleViewingSummary'); // Show spinner
    return this.http
      .post<SaleViewingLogSummary[]>(requestUrl, filter ?? {}, {
        withCredentials: false,
        observe: 'response',
      })
      .pipe(
        map((res: any) => {
          if (res.error) {
            throw new Error(res.error);
          }
          return res.body;
        }),
        catchError((error: Error) => {
          this.onError.next(error.message);
          return throwError(error);
        }),
        finalize(() => this.spinnerService.popRequest('getSaleViewingSummary')) // Hide spinner on completion
      );
  }

  public getConsignorSales(saleUID: string, consignorUID?: string): Observable<LookupModel[]> {
    let requestUrl = `${this.baseUrl}/api/Sales/${saleUID}/stats/consignor/sales`;
    if (consignorUID !== null) {
      requestUrl = `${requestUrl}?consignorUID=${consignorUID}`;
    }

    this.spinnerService.addRequest('getConsignorSales'); // Show spinner
    return this.http
      .get<LookupModel[]>(requestUrl, {
        withCredentials: false,
        observe: 'response',
      })
      .pipe(
        map((res: any) => {
          if (res.error) {
            throw new Error(res.error);
          }
          return res.body;
        }),
        catchError((error: Error) => {
          this.onError.next(error.message);
          return throwError(error);
        }),
        finalize(() => this.spinnerService.popRequest('getConsignorSales')) // Hide spinner on completion
      );
  }

  public markAsArchive(activityLogId: number,active:boolean): Observable<boolean> {
    let requestUrl = `${this.baseUrl}/api/activity/${activityLogId}/${active}/status`;
    this.spinnerService.addRequest('markAsArchive'); // Show spinner
    return this.http
      .patch<Boolean>(requestUrl, {
        withCredentials: false,
        observe: 'response',
      })
      .pipe(
        map((res: any) => {
          if (res.error) {
            throw new Error(res.error);
          }
          return res.body;
        }),
        catchError((error: Error) => {
          this.onError.next(error.message);
          return throwError(error);
        }),
        finalize(() => this.spinnerService.popRequest('markAsArchive')) // Hide spinner on completion
      );
  }
}
